import { render, staticRenderFns } from "./TransferDomain.vue?vue&type=template&id=362eac1f&scoped=true"
import script from "./TransferDomain.vue?vue&type=script&lang=js"
export * from "./TransferDomain.vue?vue&type=script&lang=js"
import style0 from "./TransferDomain.vue?vue&type=style&index=0&id=362eac1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362eac1f",
  null
  
)

export default component.exports